const TableLoad = () => {
  return (
    <div className="absolute inset-0 flex items-center justify-center bg-white/50 blur-xs z-[1]">
      {/* <div className="border-t-4 border-[#2B0C1A] rounded-full w-16 h-16 animate-spin z-[999]"></div> */}
      <div className="loading-dots flex space-x-1 justify-center h-[20px] items-center Z-[20]">
        <span className="sr-only">Loading...</span>
        <div className="h-3 w-3 bg-[#2B0C1A] rounded-full animate-bounce [animation-delay:-0.6s]"></div>
        <div className="h-3 w-3 bg-[#2B0C1A] rounded-full animate-bounce [animation-delay:-0.3s]"></div>
        <div className="h-3 w-3 bg-[#2B0C1A] rounded-full animate-bounce"></div>
      </div>
    </div>
  );
};

export default TableLoad;
